module.exports = __webpack_public_path__ + "static/media/07.5be0be3e.jpg";